import { Stack } from "@mui/material";
import { Typography } from "components";

interface InfoCardProps {
  title: string;
  rightNode?: React.ReactNode;
  children: React.ReactNode;
}

const InfoCard = (props: InfoCardProps) => {
  const { title, children, rightNode } = props;
  return (
    <Stack width="100%" borderRadius="12px">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {title && (
          <Typography fontWeight={600} type="TextLG" color="grey.900">
            {title}
          </Typography>
        )}
        {rightNode && rightNode}
      </Stack>
      {children}
    </Stack>
  );
};

interface ItemProps {
  title: string;
  description?: string;
  rowGap?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const Item = (props: ItemProps) => {
  const { title, children, description, icon, rowGap } = props;
  return (
    <Stack rowGap={rowGap || "6px"} alignItems="space-between" height="100%">
      <Stack direction="row" justifyContent="space-between">
        <Typography fontWeight={500} type="TextXS" color="grey.700">
          {title}
        </Typography>
      </Stack>
      {children || (
        <Stack direction="row" alignItems="center" columnGap="6px">
          {icon}
          <Typography
            fontWeight={500}
            type="TextMD"
            color="grey.700"
            sx={{ "& ul": { padding: "0 16px", margin: 0 } }}
            dangerouslySetInnerHTML={{ __html: String(description) }}
          />
        </Stack>
      )}
    </Stack>
  );
};
export { Item };
export default InfoCard;
